const initialState = {
    offers: []
};

export default function cfg(state = initialState, action) {
    switch (action.type) {
        case 'SET_CFG_OFFERS':
            return {
                ...state,
                offers: action.value,
            };
        default:
            return state;
    }
}
